import { observer } from 'mobx-react-lite';
import { useEffect, useRef } from 'react';

import { useMst } from '../../../models/rootModel';

import { useAnalytics } from '../../../utils/analytics';
import { sendGTMEvent } from '../../../utils/googleTagManager';
import { BaseStepPropsV3 } from './BaseStepV3.types';

export const BaseStepV3: React.FC<BaseStepPropsV3> = observer((props: BaseStepPropsV3) => {
  const { UserDiscoveryResponse, Step } = useMst();

  const { isActive, title, stepType } = props;

  const analytics = useAnalytics();
  const segmentObject = useRef({
    stepId: props.stepName,
    stepType: stepType,
    stepIndex: props.stepIndex,
    stepTitle: props.title,
    ...UserDiscoveryResponse.utms,
    origin: Step.origin,
    userID: UserDiscoveryResponse.accountId,
  });

  useEffect(() => {
    if (isActive) {
      sendGTMEvent({
        event: 'page_view',
        page_location: `${window.location.href}/${props.stepName}`,
        page_title: `Onboarding - ${title}`,
        user_id: UserDiscoveryResponse.accountId,
      });
    }
  }, [isActive, UserDiscoveryResponse.accountId, title, props.stepName]);

  useEffect(() => {
    if (isActive) {
      analytics.track(`view onboarding step`, { ...segmentObject.current, referringUrl: document.referrer });
    }
  }, [isActive, analytics, segmentObject, stepType]);

  useEffect(() => {
    if (UserDiscoveryResponse.accountId) {
      analytics.identify(UserDiscoveryResponse.accountId);
    }
  }, [UserDiscoveryResponse.accountId, analytics]);

  if (!isActive) {
    return null;
  }

  return <>{props.children}</>;
});
